import { RootState } from '@/store/store'
import { UserFilesBatchingState, UserFilesBatchedOperation, UserFilesBatchedOperationStatus } from './slice'

export const selectUserFilesBatchingState = (state: RootState): UserFilesBatchingState => state.userFilesBatchingState

export const selectActiveUserFilesOperation = (state: RootState): UserFilesBatchedOperation | null => state.userFilesBatchingState.activeOperation

export const selectIsUserFilesOperationActive = (state: RootState): boolean => {
  const op = selectActiveUserFilesOperation(state)
  return op !== null && (op.status === UserFilesBatchedOperationStatus.Queued || op.status === UserFilesBatchedOperationStatus.Running)
}
